import { t } from 'i18next';
import { ReactNode } from 'react';
import styled from 'styled-components';

import Icon from './Icon';

interface IProps {
  label?: string;
  content?: string;
  editable?: boolean;
  onEditIconClicked?: () => void;
  onRemoveIconClicked?: () => void;
}

const editIconStyle = {
  fontSize: 13,
};

const removeIconStyle = {
  fontSize: 18,
};

const NoteWrapper = styled.div`
  display: flex;
  align-content: center;
  justify-content: space-between;
  margin-bottom: 3px;
  font-size: 13px;
  margin-top: 7px;
`;

type NoteContentProps = { children?: ReactNode };

const NoteContent = styled.div<NoteContentProps>`
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: flex-start;

  p {
    margin: 0;
  }
`;

type NoteLabelProps = { children?: ReactNode };

const NoteLabel = styled.span<NoteLabelProps>`
  font-weight: 600;
  text-transform: uppercase;

  margin-right: 3px;
`;

type ButtonsWrapperProps = { children?: ReactNode };

const ButtonsWrapper = styled.span<ButtonsWrapperProps>`
  display: flex;
  align-items: flex-start;
`;

/** @deprecated */
const Note = ({
  label = t('labelNote'),
  content,
  editable = false,
  onEditIconClicked,
  onRemoveIconClicked,
}: IProps) => {
  return (
    <NoteWrapper>
      <NoteContent>
        {label && <NoteLabel>{label}:</NoteLabel>}
        <span
          dangerouslySetInnerHTML={{
            __html: content,
          }}
        />
      </NoteContent>

      {editable && (
        <ButtonsWrapper>
          <Icon name={Icon.PENCIL} style={editIconStyle} onClick={onEditIconClicked} hover />

          <Icon name={Icon.CLEAR} style={removeIconStyle} onClick={onRemoveIconClicked} hover />
        </ButtonsWrapper>
      )}
    </NoteWrapper>
  );
};

export default Note;
